import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { siteImagery } from '../config/siteImagery';
import { Container } from '../components/layout/Primitives';

const looks = [
  { src: siteImagery.heroMain, title: 'Volume I', subtitle: 'The Tailoring Edit', wide: true },
  { src: siteImagery.look1, title: 'Volume II', subtitle: 'After Hours' },
  { src: siteImagery.look2, title: 'Volume III', subtitle: 'Architectures' },
  { src: siteImagery.catWomen, title: 'Volume IV', subtitle: 'In Gold' },
  { src: siteImagery.look3, title: 'Volume V', subtitle: 'Together' },
  { src: siteImagery.catMen, title: 'Volume VI', subtitle: 'The Overcoat' },
  { src: siteImagery.catAccessories, title: 'Volume VII', subtitle: 'The Accessories' },
];

export default function Lookbook() {
  return (
    <div className="animate-fade-in">
      <section style={{ background: '#000', color: 'hsl(40,30%,96%)', padding: 'clamp(4rem,10vw,8rem) 1.5rem', textAlign: 'center' }}>
        <p className="font-mono-luxe" style={{ margin: '0 0 1.25rem', color: '#F5F2EB', fontSize: '11px', letterSpacing: '0.3em' }}>
          Lookbook · Autumn / Winter &apos;26
        </p>
        <h1
          className="font-display"
          style={{
            margin: 0,
            fontSize: 'clamp(2.75rem,8vw,5.5rem)',
            lineHeight: 0.95,
            width: '95%',
            maxWidth: '2200px',
            marginInline: 'auto',
          }}
        >
          A Study in{' '}
          <em style={{ color: '#F5F2EB', fontStyle: 'italic' }}>
            Noir
          </em>
        </h1>
        <p style={{ margin: '1.75rem auto 0', maxWidth: '36rem', opacity: 0.7 }}>
          Seven volumes. One ongoing meditation on shadow, light and the quiet power of black.
        </p>
      </section>

      <Container style={{ padding: '4rem 1.5rem' }}>
        <style>{`@media(min-width:1024px){.lb-wide{grid-column:span 2!important;grid-row:span 2!important}}`}</style>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '1rem',
            gridAutoRows: 'minmax(420px, auto)',
          }}
          className="lb-grid"
        >
          <style>{`@media(min-width:1024px){.lb-grid{grid-template-columns:repeat(3,1fr)!important;gap:1.5rem!important}}`}</style>
          {looks.map((l, i) => (
            <div
              key={i}
              className={l.wide ? 'lb-wide' : ''}
              style={{
                position: 'relative',
                overflow: 'hidden',
                background: 'hsl(38,25%,90%)',
                minHeight: '420px',
              }}
            >
              <img
                src={l.src}
                alt={l.title}
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 1.5s cubic-bezier(0.22,1,0.36,1)',
                }}
              />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, hsla(0,0%,0%,0.65), transparent)', opacity: 0.85 }} />
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '1.5rem', color: 'hsl(40,30%,96%)' }}>
                <p className="font-mono-luxe" style={{ margin: 0, fontSize: '11px', color: '#F5F2EB' }}>{l.subtitle}</p>
                <h3 className="font-display" style={{ margin: '0.25rem 0 0', fontSize: 'clamp(1.5rem,3vw,2.25rem)' }}>{l.title}</h3>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '4rem' }}>
          <Button as={Link} to="/shop/new" $variant="luxe" $size="lg">
            Shop the Collection
          </Button>
        </div>
      </Container>
    </div>
  );
}
